import { createSvgIcon } from "@mui/material";
import { DivIcon } from "leaflet";
import { renderToString } from "react-dom/server";

const markerIconSize = [40, 40];
const markerIconAnchor = [20, 40];
const popupAnchor = [0, -24];

const svg = () => {
  return (
    <svg fill="#000000" width="40px" height="40px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path id="secondary" d="M12,18a1,1,0,0,1-1-1V9a1,1,0,0,1,2,0v8A1,1,0,0,1,12,18Z" style={{ fill: "rgb(44, 169, 188)" }}></path>
      <path id="primary" d="M12,22c-2.8,0-5-1.56-5-3.54a2.43,2.43,0,0,1,.12-.77,1,1,0,0,1,1.9.62.61.61,0,0,0,0,.15C9,19.19,10.28,20,12,20s3-.81,3-1.54a.52.52,0,0,0,0-.14,1,1,0,1,1,1.9-.64,2.5,2.5,0,0,1,.12.78C17,20.44,14.8,22,12,22ZM12,2a4,4,0,1,0,4,4A4,4,0,0,0,12,2Z"></path>
    </svg >
  );
}

const IconPin = createSvgIcon(svg(), "IconPin");

const cafeClassName = "mapicon icon-pin-cafe"
export const IconPinCafe = () => { return <IconPin className={cafeClassName} />; }
export const MarkerIconPinCafe = new DivIcon({
  html: renderToString(svg()),
  iconSize: markerIconSize,
  iconAnchor: markerIconAnchor,
  className: cafeClassName,
  popupAnchor: popupAnchor
});

const shopFoodClassName = "mapicon icon-pin-shopFood";
export const IconPinShopFood = () => { return <IconPin className={shopFoodClassName} />; }
export const MarkerIconPinShopFood = new DivIcon({
  html: renderToString(svg()),
  iconSize: markerIconSize,
  iconAnchor: markerIconAnchor,
  className: shopFoodClassName,
  popupAnchor: popupAnchor
});

const shopInteriorDesignClassName = "mapicon icon-pin-shopInteriorDesign";
export const IconPinShopInteriorDesign = () => { return <IconPin className={shopInteriorDesignClassName} />; }
export const MarkerIconPinShopInteriorDesign = new DivIcon({
  html: renderToString(svg()),
  iconSize: markerIconSize,
  iconAnchor: markerIconAnchor,
  className: shopInteriorDesignClassName,
  popupAnchor: popupAnchor
});

const shopClothesClassName = "mapicon icon-pin-shopClothes";
export const IconPinShopClothes = () => { return <IconPin className={shopClothesClassName} />; }
export const MarkerIconPinShopClothes = new DivIcon({
  html: renderToString(svg()),
  iconSize: markerIconSize,
  iconAnchor: markerIconAnchor,
  className: shopClothesClassName,
  popupAnchor: popupAnchor
});

const gardenClassName = "mapicon icon-pin-garden";
export const IconPinGarden = () => { return <IconPin className={gardenClassName} />; }
export const MarkerIconPinGarden = new DivIcon({
  html: renderToString(svg()),
  iconSize: markerIconSize,
  iconAnchor: markerIconAnchor,
  className: gardenClassName,
  popupAnchor: popupAnchor
});

const craftClassName = "mapicon icon-pin-craft";
export const IconPinCraft = () => { return <IconPin className={craftClassName} />; }
export const MarkerIconPinCraft = new DivIcon({
  html: renderToString(svg()),
  iconSize: markerIconSize,
  iconAnchor: markerIconAnchor,
  className: craftClassName,
  popupAnchor: popupAnchor
});

const fleaMarketClassName = "mapicon icon-pin-fleaMarket";
export const IconPinFleaMarket = () => { return <IconPin className={fleaMarketClassName} />; }
export const MarkerIconFleaMarket = new DivIcon({
  html: renderToString(svg()),
  iconSize: markerIconSize,
  iconAnchor: markerIconAnchor,
  className: fleaMarketClassName,
  popupAnchor: popupAnchor
});

const bakeryClassName = "mapicon icon-pin-bakery";
export const IconPinBakery = () => { return <IconPin className={bakeryClassName} />; }
export const MarkerIconBakery = new DivIcon({
  html: renderToString(svg()),
  iconSize: markerIconSize,
  iconAnchor: markerIconAnchor,
  className: bakeryClassName,
  popupAnchor: popupAnchor
});

const multiClassName = "mapicon icon-pin-multi";
export const IconPinMulti = () => { return <IconPin className={multiClassName} />; }
export const MarkerIconMulti = new DivIcon({
  html: renderToString(svg()),
  iconSize: markerIconSize,
  iconAnchor: markerIconAnchor,
  className: multiClassName,
  popupAnchor: popupAnchor
});

